import { categoryService } from './categoryService'

/**
 * The category module façade. No store: the tree is small, every consumer fetches it on mount, and
 * only the admin app writes to it.
 */
export const useCategory = () => {
  return {
    category: {
      service: categoryService()
    }
  }
}
